import { Component, OnInit, ViewChild, TemplateRef, Input } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Columns, Config, DefaultConfig, API, APIDefinition } from 'ngx-easy-table';
import { IntranetoldService } from '../../../api/intranetold.service';
import { MongoService } from '../../../api/mongo.service';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MODELO_APROBACION } from "./../../../model/Mongo"
import Swal from 'sweetalert2';
import { stringify } from 'querystring';
import { IndesadService } from 'src/app/api/indesad.service';




@Component({
    selector: 'app-addEditModeloAprobacion',
    templateUrl: './addEdit.html',
    styleUrls: ['./modeloAprobacion.component.sass']
})

export class ModeloAprobacionAddEditComponent implements OnInit {
    @Input() anyDataForm: any;
    constructor(
        public activeModal: NgbActiveModal,
        private _api: IntranetoldService,
        private _apiMongo: MongoService,
        private modalService: NgbModal,
        private _apiIndesad: IndesadService,
    ) {
    }
    data: MODELO_APROBACION = {};
    JSONstring: string = "";

    public configuration: Config;
    public columns: Columns[];
    ngOnInit(): void {
        this.cargaInicial();

    }
    aprobadores: any;
    async cargaInicial() {
        var data: any = await this._api.getAllLogin();
        this.aprobadores = data.objeto;
        this.aprobadores.sort((a, b) => (b.NOMBRE - a.NOMBRE));
        this.JSONstring = "{\n\n        \"UserFields\": [\n            {\n                \"Field\": \"U_IND_Contacto\",\n                \"FieldType\": \"string\",\n                \"Value\": \"Francisco Bernales\"\n            },\n            {\n                \"Field\": \"U_IND_Telefono\",\n                \"FieldType\": \"string\",\n                \"Value\": 1111111\n            },\n            {\n                \"Field\": \"U_IND_Mail\",\n                \"FieldType\": \"string\",\n                \"Value\": \"francisco@bernales.cl\"\n            }\n        ],\n        \"Draft\": false,\n        \"SubObjType\": null,\n        \"DocEntry\": -1,\n        \"DocNum\": -1,\n        \"CardCode\": \"76293626-7\",\n        \"CardName\": \"SERVICIOS AUDIOVISUALES AVCORP LTDA.\",\n        \"Currency\": \"CLP\",\n        \"NumAtCard\": null,\n        \"Series\": -1,\n        \"DocType\": \"I\",\n        \"U_IND_Contacto\": \"Francisco Bernales\",\n        \"U_IND_Telefono\": 1111111,\n        \"U_IND_Mail\": \"francisco@bernales.cl\",\n        \"ShipToCode\": null,\n        \"PayToCode\": null,\n        \"Address\": \"GENERAL MIRANDA 684 FORESTAL, SANTIAGO, SANTIAGO\",\n        \"Address2\": null,\n        \"GroupNum\": -1,\n        \"TrnspCode\": 1,\n        \"U_IND_Tipo_E\": null,\n        \"TaxDate\": \"2022-07-06\",\n        \"DocDueDate\": \"2022-07-06\",\n        \"DocDate\": \"2022-07-05\",\n        \"ObjType\": \"23\",\n        \"SlpCode\": 1,\n        \"OwnerCode\": null,\n        \"Comments\": \"\",\n        \"GrossProfit\": 3750,\n        \"DiscPrcnt\": 0,\n        \"DiscTotal\": 0,\n        \"TotalExpns\": 0,\n        \"VatSum\": 712.5,\n        \"DocTotal\": 4462.5,\n        \"Detalles\": [\n            {\n                \"key\": \"0\",\n                \"LineNum\": null,\n                \"BaseEntry\": -1,\n                \"BaseLine\": -1,\n                \"BaseType\": null,\n                \"Account\": null,\n                \"ItemCode\": \"F00017\",\n                \"Dscription\": \"CORD CAT 6 UTP 7 MT GRIS 100% COBRE\",\n                \"Factor1\": 1,\n                \"Factor2\": 1,\n                \"Quantity\": 1,\n                \"Price\": 3750,\n                \"Disc\": 0,\n                \"PriceAfeterDisc\": 3750,\n                \"LineTotal\": 3750,\n                \"OnHand\": 200,\n                \"TaxCode\": \"IVA\",\n                \"WhsCode\": \"CENTRAL\",\n                \"DimCode1\": null,\n                \"DimCode2\": null,\n                \"DimCode3\": null,\n                \"DimCode4\": null,\n                \"DimCode5\": null,\n                \"Currency\": \"CLP\",\n                \"Lote\": [],\n                \"ManBtchNum\": \"N\",\n                \"ManSerNum\": \"N\",\n                \"CantidadPickeada\": null,\n                \"CantidadPendiente\": null\n            }\n        ],\n        \"BillToDef\": \"GENERAL MIRANDA 684 FORESTAL\",\n        \"ShipToDef\": \"GENERAL MIRANDA 684 FORESTAL\",\n        \"ListaDePrecioSocio\": 1,\n        \"ListaCUrrency\": false,\n        \"AddresList\": {\n            \"StreetS\": \"GENERAL MIRANDA 684 FORESTAL\",\n            \"StreetNoS\": null,\n            \"BlockS\": null,\n            \"CityS\": \"SANTIAGO\",\n            \"ZipCodes\": null,\n            \"CountyS\": \"SANTIAGO\",\n            \"StateS\": \"13\",\n            \"CountryS\": \"CL\",\n            \"BuildingS\": null,\n            \"Address2S\": null,\n            \"Address3S\": null,\n            \"GlbLocNumS\": null,\n            \"StreetB\": null,\n            \"StreetNoB\": null,\n            \"BlockB\": null,\n            \"CityB\": null,\n            \"ZipCodeB\": null,\n            \"CountyB\": null,\n            \"StateB\": null,\n            \"CountryB\": null,\n            \"BuildingB\": null,\n            \"Address2B\": null,\n            \"Address3B\": null,\n            \"GlbLocNumB\": null\n        }\n    \n}";

    }
    agregarAprobador() {
        this.data.APROBADORES.push({
            id: "",
            MENSAJE: "",
            NOMBRE: ""
        });
    }
    async guardarEditar() {
        this.data.APROBADORES.forEach(element => {
            this.aprobadores.forEach(element2 => {

                if (element.id == element2._id) {

                    element.NOMBRE = element2.NOMBRE;
                }
            });
        });

        var data: any = await this._apiMongo.addEditModeloAprobacion(this.data);
        this.data = data.resultado;
        if (data.estado) {
            Swal.fire("Mensaje", data.mensaje, "success");
        }
        else {
            Swal.fire("Mensaje", data.mensaje, "error");
        }
    }


    cerrar() {
        this.activeModal.close();
    }
    btnTestJSON() {

    }
    async btnTestQuery() {
        var json = {
            modelo_aprobacion: (this.data),
            documento: JSON.parse(this.JSONstring),
        }
        


        var datos = await this._apiIndesad.EnviaDocumentoAprobacionTEST(json);
        
    }



}